import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api, asArray } from "../../lib/api";
import { BlogCard } from "../site/BlogCard";
import { Reveal, Eyebrow, MaskLines } from "../site/Reveal";

export const LatestBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  useEffect(() => {
    api.get("/blogs", { params: { limit: 3 } }).then((r) => setBlogs(asArray(r))).catch(() => setBlogs([]));
  }, []);
  if (!blogs.length) return null;

  return (
    <section data-testid="latest-blogs" className="bg-paper-2 py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-14">
          <div>
            <Eyebrow>Insights</Eyebrow>
            <h2 className="mt-6 font-display font-extrabold tracking-[-0.035em] leading-[0.95] text-4xl sm:text-6xl">
              <MaskLines inView lines={[<>Notes from the <span className="font-serif-i text-[var(--brass-deep)]">desk.</span></>]} />
            </h2>
          </div>
          <Link to="/blogs" data-testid="all-blogs-link" className="group inline-flex items-center gap-2 font-semibold border-b border-ink pb-1 self-start sm:self-auto">
            All insights <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:rotate-45" />
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {blogs.map((b, i) => (
            <Reveal key={b.id} delay={i * 0.1}><BlogCard blog={b} index={i} /></Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
